import { useEffect, useState } from "react";
import Loading from "../loading/Loading";
import { Link } from "react-router-dom";
import { Alert, Button, Form, Table } from "react-bootstrap";
import { getOrders, setOrdersToken, updateOrderDeliveryStatus } from "../../controllers/orders";
import OrderDetailsModal from "../orders/OrderDetailsModal";
import { useAuth } from "../auth/AuthProvider";

function OrdersNacional({}) {
  const { token } = useAuth();
  const [orders, setOrders] = useState();
  const [showPayModal, setShowPayModal] = useState(false);
  const [modalOrder, setModalOrder] = useState();
  setOrdersToken(token);

  useEffect(() => {
    loadHistory();
  }, []);

  async function loadHistory() {
    console.log('getting orders');
    let o = await getOrders({
      orderType: 'material',
    });
    setOrders(o);
  }

  if (!orders) {
    return <Loading />
  }
  else if (!orders.length) {
    return <Alert variant="warning">No se encontraron órdenes.</Alert>
  }

  function showModal(e) {
    e.preventDefault();
    let o = orders.find(or => or.order_id === parseInt(e.target.dataset.order_id));
    setModalOrder(o);
  }
  function hideModal() {
    setModalOrder(false);
  }

  function StatusUpdateForm({ orderId }) {
    const [status, setStatus] = useState('');
    async function onSubmit(e) {
      e.preventDefault();
      console.log(`Updating status of order: ${orderId}. Status: ${status}`);
      if (!status) {
        return;
      }
      try {
        await updateOrderDeliveryStatus(orderId, status);
        console.log('Successfully updated order.');
        loadHistory();
      }
      catch(e) {
        console.log(e);
      }
    }
    return <Form onSubmit={onSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Actualizar a:</Form.Label>
        <Form.Select onChange={e => setStatus(e.target.value)}>
          <option value=''>Selecciona un estado</option>
          <option value='en proceso'>En Proceso</option>
          <option value='enviado'>Enviado</option>
          <option value='entregado'>Entregado</option>
          <option value='cancelada'>Cancelada</option>
        </Form.Select>
      </Form.Group>
      <Button type="submit">Guardar</Button>
    </Form>
  }
  
  function renderOrders() {
    return orders.map((o, i) => {
      let fecha = new Date(o.createdAt);
      let total = 0;
      o.line_items.forEach(li => {
        total += parseInt(li.product_original_price) * li.quantity;
      });
      return <tr key={`order-${o.order_id}`}>
        <td>{o.order_id}</td>
        <td>{fecha.toLocaleDateString()} {fecha.toLocaleTimeString()}</td>
        <td>
          {o.membership.user.email}<br/><br/>
          {o.formatUserData.nombres}<br/>
          {o.formatUserData.direccion}
        </td>
        <td className={o.order_status === 'Pagada' ? 'text-success': 'text-danger'}>
          {o.order_status}
        </td>
        <td>
          <b style={{textTransform: 'capitalize'}}>{o.delivery_status}</b><br/><br/>
          <StatusUpdateForm orderId={o.order_id} />
        </td>
        <td>${total}</td>
        <td>Comunidad: <b>{o.membership.comunidad?.label}</b><br/>{o.membership.region?.label} / {o.membership.diocesis?.label}</td>
        <td>
          <Link onClick={showModal} data-order_id={o.order_id}>Ver detalles</Link>
        </td>
      </tr>
    });
  }

  return <>
    <Table striped hover>
      <thead>
        <tr>
          <td>Número de orden</td>
          <td>Fecha</td>
          <td>Usuario</td>
          <td>Pagado</td>
          <td>Estatus</td>
          <td>Monto</td>
          <td>Comunidad</td>
          <td>Detalles</td>
        </tr>
      </thead>
      <tbody>
        {renderOrders()}
      </tbody>
    </Table>
    <OrderDetailsModal
      show={!!modalOrder} 
      handleClose={hideModal} 
      order={modalOrder}
    />
  </>;
}

export default OrdersNacional;